import axios from 'axios';
import qs from 'qs';
import utils from './utils';
import { message } from 'heyui';
import { ensureDesktopAuth } from './desktop-auth';

const DefaultParam = { repeatable: false };
let authRedirecting = false;
let loggingOut = false;

export function beginLogout() {
  loggingOut = true;
  authRedirecting = true;
}

export function endLogout() {
  loggingOut = false;
  authRedirecting = false;
}

function redirectToLogin() {
  if (authRedirecting || loggingOut) {
    return;
  }
  authRedirecting = true;
  try {
    utils.removeLocal('token');
    utils.removeLocal('username');
    utils.removeLocal('SYS_USER_MENUS');
  } catch (e) {
    // ignore storage errors
  }

  const target = window.top || window;
  ensureDesktopAuth()
    .then((ok) => {
      if (ok) {
        authRedirecting = false;
        const path = (target.location && target.location.pathname) || '';
        if (path === '/login') {
          target.location.replace('/');
        } else {
          target.location.reload();
        }
        return;
      }
      const path = (target.location && target.location.pathname) || '';
      if (path === '/login') {
        authRedirecting = false;
        return;
      }
      target.location.replace('/login');
    })
    .catch(() => {
      target.location.replace('/login');
    });
}

let ajax = {
  PREFIX: '/api',
  Author: utils.getAuthor() || 'heyui',
  requestingApi: new Set(),
  extractUrl: function (url) {
    return url ? url.split('?')[0] : '';
  },
  isRequesting: function (url) {
    let api = this.extractUrl(url);
    return this.requestingApi.has(api);
  },
  addRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.add(api);
  },
  deleteRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.delete(api);
  },
  get: function (url, param, extendParam) {
    let params = {
      url,
      method: 'GET'
    };
    if (param) {
      params.params = param;
    }
    return this.ajax(params, extendParam);
  },
  post: function (url, param, extendParam) {
    var params = {
      url,
      method: 'POST'
    };
    if (param) params.data = qs.stringify(param);
    return this.ajax(params, extendParam);
  },
  postJson: function (url, paramJson, extendParam) {
    return this.ajax({
      url,
      method: 'POST',
      data: paramJson
    }, extendParam);
  },
  patchJson: function (url, paramJson, dataType, extendParam) {
    return this.ajax({
      url,
      method: 'PATCH',
      data: paramJson
    }, extendParam);
  },
  delete: function (url, extendParam) {
    return this.ajax({
      url: url,
      method: 'DELETE'
    }, extendParam);
  },
  ajax: function (param, extendParam) {
    let params = utils.extend({}, DefaultParam, param, extendParam || {});
    params.crossDomain = params.url.indexOf('http') === 0;
    let url = params.url;
    if (!params.crossDomain) {
      url = params.url = this.PREFIX + params.url;
    }
    if (params.method != 'GET') {
      if (this.isRequesting(url)) {
        return new Promise((resolve) => { resolve({ ok: false, msg: '重复请求' }); });
      }
      if (params.repeatable === false) {
        this.addRequest(url);
      }
    }
    let header = {
      author: this.Author,
      Authorization: utils.getLocal('token')
    };
    let defaultParam = {
      headers: header,
      responseType: 'json',
      validateStatus: function (status) {
        return true;
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { allowDots: true });
      }
    };
    if (params.crossDomain) {
      defaultParam.headers = {};
    }
    let that = this;
    params = utils.extend({}, defaultParam, params);
    return new Promise((resolve) => {
      return axios.request(params).then((response) => {
        that.deleteRequest(params.url);
        let data = response.data;
        let status = response.status;
        if (status != 200) {
          if (status == 401) {
            if (!loggingOut) {
              redirectToLogin();
            }
            resolve({ ok: false, status: 401, _msg: (data && data.detail) || '未登录或登录已过期' });
            return;
          }
          if (status == 500) {
            message.error('后台异常');
          } else if (status == 404) {
            message.error('请求不存在');
          } else if (status != 200) {
            message.error(data._msg || '请求异常');
          }
        }
        data.ok = data.status == 200;
        resolve(data);
      }).catch(() => {
        that.deleteRequest(params.url);
        resolve({
          ok: false
        });
      });
    });
  }
};
export default ajax;
